import route from "mock/route";
import { Children } from "react";

/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: "/user",
    layout: false,
    routes: [
      {
        name: "login",
        path: "/user/login",
        component: "./user/login",
      },
    ],
  },
  {
    path: "/data-view",
    name: "大屏",
    layout: false,
    icon: "desktop",
    component: "./dataView/index",
  },
  //=========================================== 非居民管理 =============================
  {
    path: "/base-info",
    name: "基本信息",
    code: "base_info",
    icon: "database",
    routes: [
      {
        path: "/base-info/area",
        name: "服务片区",
        code: "area",
        icon: "environment",
        component: "./base-info/area",
      },
      {
        path: "/base-info/area/add",
        name: "新建片区",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/area/form",
      },
      {
        path: "/base-info/area/edit",
        name: "编辑片区",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/area/form",
      },
      {
        path: "/base-info/customer",
        name: "商户信息",
        code: "merchant",
        icon: "user",
        component: "./base-info/customer",
      },

      {
        path: "/base-info/customer/add",
        name: "新建商户",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/customer/form",
      },
      {
        path: "/base-info/customer/edit",
        name: "编辑商户",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/customer/form",
      },
      {
        path: "/base-info/customer/view",
        name: "查看商户",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/customer/form",
      },
      {
        path: "/base-info/contract/add",
        name: "新增签订合同",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/customer/contract/form",
      },
      {
        path: "/base-info/contract/edit",
        name: "编辑合同",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/customer/contract/form",
      },
      {
        path: "/base-info/contract/view",
        name: "查看合同",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/customer/contract/view",
      },
      {
        path: "/base-info/customer-search",
        name: "商户搜索",
        code: "merchant_search",
        icon: "user",
        component: "./base-info/customerSearch",
      },
      {
        path: "/base-info/contract/adds",
        name: "新增签订合同",
        icon: "environment",
        hideInMenu: true,
        component: "./base-info/customer/contract/form",
      },

      {
        path: "/base-info/rfid",
        name: "桶RFID信息",
        icon: "setting",
        component: "./base-info/rfid",
      },
      {
        path: "/base-info/rfid/add",
        name: "新建桶RFID",
        icon: "setting",
        hideInMenu: true,
        component: "./base-info/rfid/form",
      },
      {
        path: "/base-info/rfid/edit",
        name: "编辑桶RFID",
        icon: "setting",
        hideInMenu: true,
        component: "./base-info/rfid/form",
      },
    ],
  },
  {
    path: "/weight-record",
    name: "称重记录",
    code: "wr_record_parent",
    icon: "history",
    routes: [
      {
        path: "/weight-record/tag",
        name: "桶标签称重记录",
        icon: "fileText",
        component: "./weight-record/tag",
      },
      {
        path: "/weight-record/no-tag",
        name: "无标签称重记录",
        icon: "fileText",
        component: "./weight-record/no-tag",
      },
    ],
  },
  {
    path: "/garbage-record",
    name: "清运记录",
    code: "wr_record_parent",
    icon: "fileSync",
    routes: [
      {
        path: "/garbage-record/record",
        name: "清运记录",
        icon: "fileText",
        component: "./garbage-record/record",
        code: "wr_record",
      },
      {
        path: "/garbage-record/add",
        name: "新建清运记录",
        icon: "fileText",
        hideInMenu: true,
        component: "./garbage-record/record/form",
      },
      {
        path: "/garbage-record/edit",
        name: "编辑清运记录",
        icon: "fileText",
        hideInMenu: true,
        component: "./garbage-record/record/form",
      },
      {
        path: "/garbage-record/query",
        name: "清运排查",
        icon: "fileText",
        code: "wr_inspection",
        component: "./garbage-record/query",
      },
      {
        path: "/garbage-record/weight",
        name: "记录称重对照表",
        component: "./garbage-record/weight",
      },
    ],
  },
  {
    path: "/vehicle-operation",
    name: "车辆作业",
    // code: "vehicle-operation",
    icon: "fileText",
    routes: [
      {
        path: "/vehicle-operation/daily-plan",
        name: "每日出车计划",
        component: "./vehicle-operation/daily-plan",
      },
      {
        path: "/vehicle-operation/job-config",
        name: "作业配置",
        component: "./vehicle-operation/job-config",
      },
      {
        path: "/vehicle-operation/merchant-notice-settings",
        name: "商户通知设置",
        component: "./vehicle-operation/merchant-notice-settings",
      },
    ],
  },

  {
    path: "/expiration-reminder",
    name: "到期提醒",
    code: "reminder",
    icon: "bell",
    component: "./expiration-reminder",
  },
  {
    path: "/reconciliation",
    name: "对账",
    code: "reconcile",
    icon: "AccountBookOutlined",
    routes: [
      {
        path: "/reconciliation/list",
        name: "对账列表",
        code: "reconcile_list",
        icon: "unorderedList",
        component: "./reconciliation/list",
      },
      {
        path: "/reconciliation/list/handle",
        name: "去对账",
        icon: "unorderedList",
        hideInMenu: true,
        component: "./reconciliation/list/handle",
      },
      {
        path: "/reconciliation/list/view",
        name: "查看",
        icon: "unorderedList",
        hideInMenu: true,
        component: "./reconciliation/list/handle",
      },
      {
        path: "/reconciliation/manual",
        name: "手动对账",
        code: "reconcile_manual",
        component: "./reconciliation/manual",
      },
      {
        path: "/reconciliation/manual/view",
        name: "查看",
        hideInMenu: true,
        component: "./reconciliation/manual/view",
      },
      {
        path: "/reconciliation/manual/handle",
        name: "新建手动对账",
        hideInMenu: true,
        component: "./reconciliation/manual/view",
      },
    ],
  },
  {
    path: "/invoice",
    name: "开票",
    code: "ticket",
    icon: "fileText",
    routes: [
      {
        path: "/invoice/list",
        name: "开票列表",
        code: "ticket_list",
        icon: "container",
        component: "./invoice/list",
      },
      {
        path: "/invoice/list/handle",
        name: "申请开票",
        hideInMenu: true,
        component: "./invoice/list/handle",
      },
      {
        path: "/invoice/list/view",
        name: "查看开票",
        hideInMenu: true,
        component: "./invoice/list/handle",
      },
      {
        path: "/invoice/manual",
        name: "手动开票",
        code: "ticket_manual",
        icon: "form",
        component: "./invoice/manual",
      },
      {
        path: "/invoice/manual/handle",
        name: "发起手动开票",
        hideInMenu: true,
        component: "./invoice/manual/handle",
      },
      {
        path: "/invoice/merchant",
        name: "商户开票",
        code: "merchant_ticket",
        icon: "form",
        component: "./invoice/merchant",
      },
    ],
  },
  {
    path: "/payment-collection",
    name: "回款",
    code: "received",
    icon: "transaction",
    routes: [
      {
        path: "/payment-collection/list",
        name: "回款列表",
        code: "received_list",
        icon: "profile",
        component: "./payment-collection/list",
      },
      {
        path: "/payment-collection/list/handle",
        name: "完成回款",
        hideInMenu: true,
        component: "./payment-collection/list/handle",
      },
      {
        path: "/payment-collection/list/view",
        name: "查看",
        hideInMenu: true,
        component: "./payment-collection/list/handle",
      },
      {
        path: "/payment-collection/manual",
        name: "手动回款",
        code: "received_manual",
        icon: "carry",
        component: "./payment-collection/manual",
      },
      {
        path: "/payment-collection/manual/handle",
        name: "新建手动回款记录",
        hideInMenu: true,
        component: "./payment-collection/manual/handle",
      },
      {
        path: "/payment-collection/manual/view",
        name: "查看",
        hideInMenu: true,
        component: "./payment-collection/manual/handle",
      },
    ],
  },
  {
    path: "/immediate-payment",
    name: "现结回款",
    code: "cash_received",
    icon: "dollarCircle",
    component: "./immediate-payment",
  },
  {
    path: "/charge",
    name: "充值",
    code: "recharge",
    icon: "wallet",
    routes: [
      {
        path: "/charge",
        name: "充值",
        hideInMenu: true,
        component: "./charge",
      },
      {
        path: "/charge/add",
        name: "充值",
        hideInMenu: true,
        component: "./charge/form",
      },
      {
        path: "/charge/view",
        name: "查看",
        hideInMenu: true,
        component: "./charge/form",
      },
    ],
  },

  {
    path: "/balance-reminder",
    name: "卡余额提醒",
    code: "balance_reminder",
    icon: "alert",
    component: "./balance-reminder",
  },
  {
    path: "/absorption",
    name: "消纳管理",
    icon: "export",
    code: "waste_disposal",
    routes: [
      {
        path: "/absorption/unit",
        name: "消纳单位",
        code: "waste_disposal_unit",
        component: "./absorption/unit",
      },
      {
        path: "/absorption/unit/add",
        name: "新建消纳单位",
        hideInMenu: true,
        component: "./absorption/unit/form",
      },
      {
        path: "/absorption/unit/edit",
        name: "编辑消纳单位",
        hideInMenu: true,
        component: "./absorption/unit/form",
      },
      {
        path: "/absorption/unit/view",
        name: "查看消纳单位",
        hideInMenu: true,
        component: "./absorption/unit/view",
      },
      {
        path: "/absorption/charge",
        name: "消纳充值",
        component: "./absorption/charge",
        code: "waste_disposal_recharge",
      },
      {
        path: "/absorption/charge/add",
        name: "新建消纳充值",
        hideInMenu: true,
        component: "./absorption/charge/form",
      },
      {
        path: "/absorption/charge/view",
        name: "查看消纳充值",
        hideInMenu: true,
        component: "./absorption/charge/form",
      },

      {
        path: "/absorption/record",
        name: "消纳记录",
        component: "./absorption/record",
        code: "waste_disposal_record",
      },
      {
        path: "/absorption/record/add",
        name: "新建消纳记录",
        hideInMenu: true,
        component: "./absorption/record/form",
      },
      {
        path: "/absorption/record/edit",
        name: "编辑消纳记录",
        hideInMenu: true,
        component: "./absorption/record/form",
      },
      {
        path: "/absorption/record/view",
        name: "查看消纳记录",
        hideInMenu: true,
        component: "./absorption/record/view",
      },
    ],
  },
  {
    path: "/wasteOrder",
    name: "订单管理",
    code: "order",
    icon: "LineChartOutlined",
    routes: [
      {
        path: "/wasteOrder",
        name: "订单管理",
        hideInMenu: true,
        component: "./wasteOrder",
      },
      {
        path: "/wasteOrder/edit",
        name: "编辑",
        hideInMenu: true,
        component: "./wasteOrder/form",
      },
      {
        path: "/wasteOrder/view",
        name: "查看",
        hideInMenu: true,
        component: "./wasteOrder/form",
      },
    ],
  },
  {
    path: "/smart-assistant",
    name: "智能问数",
    code: "ai",
    icon: "comment",
    component: "./smart-assistant",
  },
  {
    path: "/statistical",
    name: "统计分析",
    code: "data_analyse",
    icon: "barChart",
    component: "./statistical",
  },
  {
    path: "/rule-config",
    name: "规则设置",
    code: "rule_config",
    icon: "control",
    component: "./rule-config",
  },

  //==========================居民菜单==========================
  {
    path: "/rbase-info",
    name: "基本信息",
    // code: "vehicle-operation",
    icon: "solution",
    routes: [
      {
        path: "/rbase-info/subject-info",
        name: "主体信息",
        component: "./subject-info",
      },
      {
        path: "/rbase-info/subject-info/add",
        name: "新建主体",
        hideInMenu: true,
        component: "./subject-info/form",
      },
      {
        path: "/rbase-info/subject-info/edit",
        name: "编辑主体",
        hideInMenu: true,
        component: "./subject-info/form",
      },
      {
        path: "/rbase-info/rfid",
        name: "桶标RFID信息",
        component: "./rbase-info/rfid",
      },
      {
        path: "/rbase-info/rfid/add",
        name: "新建桶标RFID信息",
        hideInMenu: true,
        component: "./rbase-info/rfid/form",
      },
      {
        path: "/rbase-info/rfid/edit",
        name: "编辑桶标RFID信息",
        hideInMenu: true,
        component: "./rbase-info/rfid/form",
      },
    ],
  },
  {
    path: "/rgarbage-record",
    name: "清运记录",
    // code: "vehicle-operation",
    icon: "container",
    routes: [
      {
        path: "/rgarbage-record/bucket-tag-weighing-record",
        name: "桶标签称重记录",
        component: "./rgarbage-record/bucket-tag-weighing-record",
      },
      {
        path: "/rgarbage-record/no-tag-weighing-record",
        name: "无标签称重记录",
        component: "./rgarbage-record/no-tag-weighing-record",
      },
    ],
  },
  {
    path: "/rabsorption",
    name: "消纳管理",
    // code: "vehicle-operation",
    icon: "cloud",
    routes: [
      {
        path: "/rabsorption/unit",
        name: "消纳单位",
        // code: "waste_disposal_unit",
        component: "./rabsorption/unit",
      },
      {
        path: "/rabsorption/unit/add",
        name: "新建消纳单位",
        hideInMenu: true,
        component: "./rabsorption/unit/form",
      },
      {
        path: "/rabsorption/unit/edit",
        name: "编辑消纳单位",
        hideInMenu: true,
        component: "./rabsorption/unit/form",
      },
      {
        path: "/rabsorption/unit/view",
        name: "查看消纳单位",
        hideInMenu: true,
        component: "./rabsorption/unit/view",
      },

      {
        path: "/rabsorption/record",
        name: "消纳记录",
        component: "./rabsorption/record",
        // code: "waste_disposal_record",
      },
      {
        path: "/rabsorption/record/add",
        name: "新建消纳记录",
        hideInMenu: true,
        component: "./rabsorption/record/form",
      },
      {
        path: "/rabsorption/record/edit",
        name: "编辑消纳记录",
        hideInMenu: true,
        component: "./rabsorption/record/form",
      },
      {
        path: "/rabsorption/record/view",
        name: "查看消纳记录",
        hideInMenu: true,
        component: "./rabsorption/record/view",
      },
    ],
  },
  {
    path: "/rsmart-assistant",
    name: "智能问数",
    // code: "vehicle-operation",
    icon: "comment",
    component: "./smart-assistant",
  },
  {
    path: "/data-reporting",
    name: "数据上报",
    // code: "vehicle-operation",
    icon: "upload",
    routes: [
      {
        path: "/data-reporting/pending-report-data",
        name: "待上报数据",
        component: "./data-reporting/pending-report-data",
      },
      {
        path: "/data-reporting/pending-report-data/issue",
        name: "一键补录",
        hideInMenu: true,
        component: "./data-reporting/pending-report-data/issue",
      },
      {
        path: "/data-reporting/pending-report-data/editWeight",
        name: "编辑数据",
        hideInMenu: true,
        component: "./data-reporting/pending-report-data/edit",
      },
      {
        path: "/data-reporting/pending-report-data/edit",
        name: "编辑上报数据",
        hideInMenu: true,
        component: "./data-reporting/pending-report-data/form",
      },
      {
        path: "/data-reporting/report-config",
        name: "上报配置",
        component: "./data-reporting/report-config",
      },
      {
        path: "/data-reporting/history-record",
        name: "历史记录",
        component: "./data-reporting/history-record",
      },
      {
        path: "/data-reporting/history-record/detail",
        name: "数据明细",
        hideInMenu: true,
        component: "./data-reporting/history-record/detail",
      },
    ],
  },
  {
    path: "/data-acquisition",
    name: "数据获取",
    code: "re_data_get",
    icon: "download",
    routes: [
      {
        path: "/data-acquisition/report-subject-acquisition",
        name: "上报主体获取",
        // code: "re_report_subj_get",
        component: "./data-acquisition/report-subject-acquisition",
      },
      {
        path: "/data-acquisition/report-subject-acquisition/detail",
        name: "查看历史记录明细",
        hideInMenu: true,
        component: "./data-acquisition/report-subject-acquisition/detail",
      },
      {
        path: "/data-acquisition/report-vehicle-acquisition",
        name: "上报车辆获取",
        component: "./data-acquisition/report-vehicle-acquisition",
      },
      {
        path: "/data-acquisition/report-vehicle-acquisition/detail",
        name: "查看历史记录明细",
        hideInMenu: true,
        component: "./data-acquisition/report-vehicle-acquisition/detail",
      },

      {
        path: "/data-acquisition/report-garbage-type-acquisition",
        name: "上报垃圾类型获取",
        component: "./data-acquisition/report-garbage-type-acquisition",
      },
      {
        path: "/data-acquisition/report-garbage-type-acquisition/detail",
        name: "查看历史记录明细",
        hideInMenu: true,
        component: "./data-acquisition/report-garbage-type-acquisition/detail",
      },
    ],
  },
  //================================ 基础信息 =======================================
  {
    path: "/bvehicle-operation",
    name: "车辆管理",
    code: "ba_veh_operation",
    icon: "truck",
    routes: [
      {
        path: "/bvehicle-operation/vehicle-profile/info",
        name: "一车一档",
        hideInMenu: true,
        component: "./bvehicle-operation/vehicle-profile/info",
      },
      {
        path: "/bvehicle-operation/vehicle-profile",
        name: "一车一档",
        code: "ba_veh_one_file",
        component: "./bvehicle-operation/vehicle-profile",
      },
      {
        path: "/bvehicle-operation/vehicle-profile/add",
        name: "新建车辆",
        hideInMenu: true,
        component: "./bvehicle-operation/vehicle-profile/form",
      },
      {
        path: "/bvehicle-operation/vehicle-profile/edit",
        name: "编辑车辆",
        hideInMenu: true,
        component: "./bvehicle-operation/vehicle-profile/form",
      },

      {
        path: "/bvehicle-operation/vehicle-profile/view",
        name: "查看车辆详情",
        hideInMenu: true,
        component: "./bvehicle-operation/vehicle-profile/form",
      },
      {
        path: "/bvehicle-operation/operation-log",
        name: "运营记录",
        hideInMenu: true,
        component: "./bvehicle-operation/operation-log",
      },
      {
        path: "/bvehicle-operation/vehicle-transfer",
        name: "车辆过户",
        code: "ba_veh_trans",
        component: "./bvehicle-operation/vehicle-transfer",
      },
    ],
  },
  {
    path: "/bperson-operation/operation/people",
    name: "人员管理",
    code: "ba_staff_mgt",
    icon: "team",
    component: "./bperson-operation/operation/people",
  },
  {
    path: "/bperson-operation/operation/people",
    name: "人员管理",
     hideInMenu: true,
    routes: [
      {
        path: "/bperson-operation/operation/people/add",
        name: "新建人员",
        icon: "setting",
        hideInMenu: true,
        component: "./bperson-operation/operation/people/form",
      },
      {
        path: "/bperson-operation/operation/people/edit",
        name: "编辑人员",
        icon: "setting",
        hideInMenu: true,
        component: "./bperson-operation/operation/people/form",
      },
    ],
  },

  {
    path: "/bperson-operation/operation/boperating-entity",
    name: "运营单位管理",
    code: "ba_oper_unit_mgt",
    icon: "bank",
    component: "./bperson-operation/operation/boperating-entity",
  },
  {
    path: "/bperson-operation/operation/people/add",
    name: "新建运营单位管理",
    icon: "setting",
    hideInMenu: true,
    component: "./bperson-operation/operation/people/form",
  },
  {
    path: "/bperson-operation/operation/people/edit",
    name: "编辑运营单位管理",
    icon: "setting",
    hideInMenu: true,
    component: "./bperson-operation/operation/people/form",
  },
  {
    path: "/babsorption",
    name: "消纳管理",
    code: "ba_disposal_mgt",
    icon: "build",
    routes: [
      {
        path: "/babsorption/field",
        name: "消纳场",
        code: "ba_waste_disposal_site",
        component: "./babsorption/field",
      },
      {
        path: "/babsorption/field/add",
        name: "新建消纳场",
        hideInMenu: true,
        component: "./babsorption/field/form",
      },
      {
        path: "/babsorption/field/edit",
        name: "编辑消纳场",
        hideInMenu: true,
        component: "./babsorption/field/form",
      },
    ],
  },
  {
    path: "/business-classification",
    name: "业务分类",
    code: "ba_biz_category",
    icon: "fileText",
    routes: [
      {
        path: "/business-classification/non-resident-management",
        name: "非居民管理",
        code: "ba_no_resi_mgt",
        routes: [
          {
            path: "/business-classification/non-resident-management/area",
            name: "服务片区",
            code: "ba_serv_area",
            component: "./base-info/area",
          },
          {
            path: "/business-classification/non-resident-management/area/add",
            name: "新建服务片区",
            hideInMenu: true,
            component: "./base-info/area/form",
          },
          {
            path: "/business-classification/non-resident-management/area/edit",
            name: "编辑服务片区",
            hideInMenu: true,
            component: "./base-info/area/form",
          },
          {
            path: "/business-classification/non-resident-management/rfid",
            name: "桶RFID信息",
            code: "ba_backet_rfid_info",
            component: "./base-info/rfid",
          },
          {
            path: "/business-classification/non-resident-management/rfid/add",
            name: "新建桶RFID",
            icon: "setting",
            hideInMenu: true,
            component: "./base-info/rfid/form",
          },
          {
            path: "/business-classification/non-resident-management/rfid/edit",
            name: "编辑桶RFID",
            icon: "setting",
            hideInMenu: true,
            component: "./base-info/rfid/form",
          },
          {
            path: "/business-classification/non-resident-management/merchant-management",
            name: "商户管理",
            code: "ba_merch_mgt",
            routes: [
              {
                path: "/business-classification/non-resident-management/merchant-management/customer",
                name: "商户信息",
                code: "ba_merch_info",
                component: "./base-info/customer",
              },

              {
                path: "/business-classification/non-resident-management/merchant-management/customer/add",
                name: "新建商户",
                icon: "environment",
                hideInMenu: true,
                component: "./base-info/customer/form",
              },
              {
                path: "/business-classification/non-resident-management/merchant-management/customer/edit",
                name: "编辑商户",
                icon: "environment",
                hideInMenu: true,
                component: "./base-info/customer/form",
              },
              {
                path: "/business-classification/non-resident-management/merchant-management/customer/view",
                name: "查看商户",
                icon: "environment",
                hideInMenu: true,
                component: "./base-info/customer/form",
              },
              {
                path: "/business-classification/non-resident-management/merchant-management/contract/add",
                name: "新增签订合同",
                icon: "environment",
                hideInMenu: true,
                component: "./base-info/customer/contract/form",
              },
              {
                path: "/business-classification/non-resident-management/merchant-management/contract/edit",
                name: "编辑合同",
                icon: "environment",
                hideInMenu: true,
                component: "./base-info/customer/contract/form",
              },
              {
                path: "/business-classification/non-resident-management/merchant-management/contract/view",
                name: "查看合同",
                icon: "environment",
                hideInMenu: true,
                component: "./base-info/customer/contract/view",
              },
              {
                path: "/business-classification/non-resident-management/merchant-management/merchant-search",
                name: "商户搜索",
                code: "ba_merch_search",
                icon: "user",
                component: "./base-info/customerSearch",
              },
            ],
          },
        ],
      },
      {
        path: "/business-classification/resident-management/resident-management",
        name: "居民管理",
        code: "ba_resi_mgt",
        routes: [
          {
            path: "/business-classification/resident-management/resident-management/subject-info",
            name: "主体信息",
            code: "ba_subj_info",
            component: "./subject-info",
          },
          {
            path: "/business-classification/resident-management/resident-management/subject-info/add",
            name: "新建主体",
            hideInMenu: true,
            component: "./subject-info/form",
          },
          {
            path: "/business-classification/resident-management/resident-management/subject-info/edit",
            name: "编辑主体",
            hideInMenu: true,
            component: "./subject-info/form",
          },
          {
            path: "/business-classification/resident-management/resident-management/rfid",
            name: "桶标RFID信息",
            code: "ba_backet_rfid_info",
            component: "./rbase-info/rfid",
          },
          {
            path: "/business-classification/resident-management/resident-management/rfid/add",
            name: "新建主体",
            hideInMenu: true,
            component: "./rbase-info/rfid/form",
          },
          {
            path: "/business-classification/resident-management/resident-management/rfid/edit",
            name: "编辑主体",
            hideInMenu: true,
            component: "./rbase-info/rfid/form",
          },
        ],
      },
    ],
  },
  {
    path: "/bsmart-assistant",
    name: "智能问数",
    code: "ba_ai",
    icon: "robot",
    component: "./smart-assistant",
  },
  {
    path: "/system-config",
    name: "系统设置",
    code: "ba_sys_cofig",
    hideChildrenInMenu: true,
    icon: "tool",
    routes: [
      {
        path: "/system-config",
        name: "成员管理",
        component: "./system-config",
      },
      {
        path: "/system-config/user/add",
        name: "添加成员",
        hideInMenu: true,
        component: "./system-config/user/form",
      },
      {
        path: "/system-config/user/edit",
        name: "编辑成员",
        hideInMenu: true,
        component: "./system-config/user/form",
      },
      {
        path: "/system-config/user/view",
        name: "查看成员",
        hideInMenu: true,
        component: "./system-config/user/form",
      },
      {
        path: "/system-config/role",
        name: "角色与权限",
        component: "./system-config",
      },
      {
        path: "/system-config/role/add",
        name: "添加角色",
        hideInMenu: true,
        component: "./system-config/role/form",
      },
      {
        path: "/system-config/role/edit",
        name: "编辑角色",
        hideInMenu: true,
        component: "./system-config/role/form",
      },
      {
        path: "/system-config/role/view",
        name: "查看角色",
        hideInMenu: true,
        component: "./system-config/role/form",
      },
    ],
  },
  {
    path: "/",
    redirect: "/base-info/area",
  },
  {
    path: "*",
    layout: false,
    component: "./404",
  },
];
